import {Command, EditorState, TextSelection, Transaction} from "prosemirror-state";
import {toggleMark} from "prosemirror-commands";

import {isMarkActive} from "../../../utils/isMarkActive";
import {schema} from "../../config/schema";
import {
    openLinkInContextEditBarBySelection
} from '../../../../ui/elements/context-menu/editor/LinkInContextEditBar/openLinkInContextEditBar';

import { editorViewRef } from '../../../../ui/elements/EditorReact';
import {removeMarkByPosWithin} from "../../../utils/removeMarkByPosWithin";


export const toggleLink: Command = (state, dispatch) => {
    if (isLinkMarkActive(state)) {
        toggleLinkMark(state, dispatch)
        return true
    }

    toggleLinkMark(state, dispatch);
    const view = editorViewRef.current!;
    openLinkInContextEditBarBySelection(view, view.state, {isEditingAtOpen: true, defaultValue: ''});

    /* returning false will cancel automatic context close on action end */
    return false
}

export const isLinkMarkActive = isMarkActive(schema.marks.link);

export const toggleLinkMark = toggleMark(schema.marks.link);

export const deleteLinkMark = (state: EditorState, dispatch?: (tr: Transaction) => void, nodePos?: number) => {
    const {$cursor} = state.selection as TextSelection;
    if ($cursor) {
        nodePos = $cursor.pos;
    }
    if (nodePos && dispatch) {
        const tr = removeMarkByPosWithin(state, nodePos, schema.marks.link);
        dispatch(tr);
    } else {
        toggleLinkMark(state, dispatch);
    }
}
